import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const CreateEventSlice = createSlice({
    name: "createEvent",
    initialState,
    reducers: {
        createEventRequest(state) {
            state.loading = true;
        },
        createEventRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        createEventRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        createEventStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    createEventRequest,
    createEventRequestSuccess,
    createEventRequestError,
    createEventStateReset,
} = CreateEventSlice.actions;

export default CreateEventSlice.reducer;
